import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IndexesDataComponent } from './indexes-data.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: IndexesDataComponent,
        data: {
          title: "Ma\'lumotlar",
          breadcrumb: "Ma\'lumotlar"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndexesDataRoutingModule { }
